import React from 'react';
import { Link } from 'react-router-dom';

interface BackToDashboardProps {
  className?: string;
  /** Omit the /dashboard URL hint for compact layouts */
  showUrl?: boolean;
}

const BackToDashboard: React.FC<BackToDashboardProps> = ({ className = '', showUrl = true }) => (
  <Link
    to="/dashboard"
    className={`inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-indigo-600 transition-colors mb-6 group ${className}`}
  >
    <svg className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
    Back to Dashboard
    {showUrl && <span className="text-slate-400 group-hover:text-indigo-500">/dashboard</span>}
  </Link>
);

export default BackToDashboard;
